import React, { useEffect, useRef, useState } from 'react';

import Button from '../button/Button';
import IconButton from '../iconButton/IconButton';
import { RESPONSE } from '../../js/_constants';
import { playlistStore } from '../../store';
import { useTranslation } from 'react-i18next';
import MultiSelectInput from '../multiSelectInput/MultiSelectInput';
import { getDealershipGroupLabel } from '../../js/dealershipGroupLabel';


const values = (item: { label: string; value: string }) => item.value;

const EditPlaylistDealershipGroups = (props) => {
    const { t } = useTranslation();
    const { updatePlaylist } = playlistStore();
    const countryPrefix = t('dealership_group_country_prefix');

    const [selectedGroups, setSelectedGroups] = useState<any[]>(props.playlist.dealershipGroups
            .map(item => {
                const group = props.dealershipGroups.find(t => t[RESPONSE.ID] === item);
                return {
                    label: group ? getDealershipGroupLabel(group, countryPrefix).label : '',
                    value: item
                };
            })
            .filter(group => group.label));

    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [isVisibilityHintExpanded, setIsVisibilityHintExpanded] = useState<boolean>(false);
    const visibilityHelpRef = useRef<HTMLDivElement>(null);

    const handleGroupsSelection = selectedOptions => {
        const nextSelected = [...selectedOptions];
        setSelectedGroups(nextSelected);
    };

    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent) => {
            if (visibilityHelpRef.current && !visibilityHelpRef.current.contains(event.target as Node)) {
                setIsVisibilityHintExpanded(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    const onSaveEditClick = async () => {

        const options = {
            dealershipGroups: selectedGroups.map(values)
        };

        setIsSaving(true);

        await updatePlaylist(options);

        setIsSaving(false);

        if (props.onSuccess) {
            props.onSuccess();
        }
    };

    return (
        <div className="edit-groups">
            <div className="dealership-groups-dropdown-row">
                <MultiSelectInput
                    options={props.dealershipGroups.map(option => {
                        const groupLabel = getDealershipGroupLabel(option, countryPrefix);

                        return {
                            label: groupLabel.label,
                            value: option[RESPONSE.ID],
                            ...(groupLabel.isCountryGroup && {
                                countryGroup: {
                                    prefix: countryPrefix,
                                    countries: groupLabel.countries,
                                    overflowCountries: groupLabel.overflowCountries
                                }
                            })
                        };
                    })}
                    label={t('dealership_groups_dropdown')}
                    name="dealership-groups-dropdown"
                    onChange={handleGroupsSelection}
                    defaultValue={selectedGroups}
                    autoFocus
                />
                <div className="visibility-rules-help" ref={visibilityHelpRef}>
                    <IconButton
                        icon="question"
                        size="small"
                        className="visibility-rules-help-icon"
                        onClick={() => setIsVisibilityHintExpanded(!isVisibilityHintExpanded)}
                        name="visibility-rules-help-toggle"
                    />
                    {isVisibilityHintExpanded && (
                        <div className="visibility-rules-hint">
                            <p className="hint">{t('dealership_groups_empty_hint')}</p>
                            <table className="visibility-rules-table">
                                <thead>
                                    <tr>
                                        <th>{t('visibility_rules_selection')}</th>
                                        <th>{t('visibility_rules_result')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{t('visibility_rules_country_group')}</td>
                                        <td>{t('visibility_rules_country_group_result')}</td>
                                    </tr>
                                    <tr>
                                        <td>{t('visibility_rules_custom_group')}</td>
                                        <td>{t('visibility_rules_custom_group_result')}</td>
                                    </tr>
                                    <tr>
                                        <td>{t('visibility_rules_no_selection')}</td>
                                        <td>{t('visibility_rules_no_selection_result')}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
            {props.dealershipGroups.length > 5 && <p className="hint">{t('dealership_groups_hint')}</p>}
            <div className="b-modal-action-buttons edit-buttons">
                <Button
                    secondaryButton
                    text={t('cancel')}
                    clickHandler={props.onCancel}
                    name="cancel-edit-playlist-dealership-groups"
                />
                <Button
                    isLoading={isSaving}
                    text={t('save')}
                    clickHandler={onSaveEditClick}
                    name="save-edit-playlist-dealership-groups"
                />
            </div>
        </div>
    );
};

export default EditPlaylistDealershipGroups;
